import React from "react";
import { Experience, ProductObject } from "types";
import { Loader } from "../Loader";
import { ExperienceTile } from "./ExperienceTile";
import { NoProductsAlert } from "./NoProductsAlert";

interface ExperienceListProps {
    experiences: Experience[];
    isLoading: boolean;
    isFiltered: boolean;
}

export const ExperienceList = ({ experiences = [], isLoading, isFiltered }: ExperienceListProps) => {
    if (isLoading) {
        return <Loader size="tiny" className="p-2" text="Loading Experiences" />;
    }

    if (experiences.length === 0 && isFiltered) {
        return (
            <div className="py-15 px-10">
                <NoProductsAlert isListFiltered object={ProductObject.EXPERIENCE} />
            </div>
        );
    }

    return (
        <div>
            {isLoading ? (
                <Loader size="tiny" className="p-2" text="Loading Experiences" />
            ) : (
                <div className="py-15 px-10">
                    {experiences.length > 0 || isFiltered ? (
                        <div className="grid grid-cols-2 gap-y-10 gap-x-12">
                            {experiences.map((experience: Experience) => (
                                <ExperienceTile key={experience.id} experience={experience} />
                            ))}
                        </div>
                    ) : (
                        <NoProductsAlert object={ProductObject.EXPERIENCE} />
                    )}
                </div>
            )}
        </div>
    );
};
